import * as Yup from 'yup';
import {ILearningPathDetailsFormBaseValues, ILearningPathValidationsShape} from 'admin/resources/learning-paths/utils';

export type ILearningPathViewCreateFormBaseValues = ILearningPathDetailsFormBaseValues;

export const learningPathViewCreateFormBaseValidationSchema = Yup.object().shape(ILearningPathValidationsShape);
